import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import {
  SELECT_SCROLL_DOWN_ICON,
  type TSelectScrollDownButtonElement,
  type TSelectScrollDownButtonProps,
} from "@/ui/components/form/Select/Select.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const SelectScrollDownButton = forwardRef<TSelectScrollDownButtonElement, TSelectScrollDownButtonProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.ScrollDownButton
      data-component="SelectScrollDownButton"
      ref={ref}
      className={cn("flex cursor-default items-center justify-center py-1", className)}
      {...props}
    >
      <Icon icon={SELECT_SCROLL_DOWN_ICON} aria-hidden="true" size="sm" />
    </SelectPrimitive.ScrollDownButton>
  ),
);

SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
